import { render, staticRenderFns } from "./AnalyticsAgeColumnChart.vue?vue&type=template&id=0e89d5e9&"
import script from "./AnalyticsAgeColumnChart.vue?vue&type=script&lang=js&"
export * from "./AnalyticsAgeColumnChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports